import React from 'react';
// import './style.scoped.scss';

const SettingsTitle = ({ title }) => (
  <div id="settings-title">
    <h4>
      {title}
    </h4>
  </div>
);

export default SettingsTitle;
